import {InjectionToken} from '@angular/core';
import {ListingsService} from './listings-service.interface';

export const LISTINGS_SERVICE_TOKEN = new InjectionToken<ListingsService>('ListingsService');
